<template>
  <CContainer fluid>
    <CRow
      alignHorizontal="between"
      style="display: flex; align-content: center"
    >
      <div class="row-card-title left">
        <div>
          <div class="card-title-active">Course Record Overview</div>
          <div class="line" />
        </div>
      </div>
      
      <div class="row-card-title right">
        <div>
          <div
            @click="setViewType(viewType)"
            class="button button-icon button-grey"
          >
            {{ viewType }}
            <template v-if="viewType == 'Grid View'">
              <img src="@/assets/images/admin/Card View.svg" class="icon" />
            </template>
            <template v-else>
              <img src="@/assets/images/admin/Table View.svg" class="icon" />
            </template>
          </div>
        </div>
      </div>
    </CRow>

    <CRow>
      <div v-if="viewType == 'Table View'" class="main-card">
        <CContainer fluid>
          <CRow>
            <template v-for="(item, index) in instructorsCourseData">
              <courseCardOverview :key="index" :courseProps="item" />
            </template>
          </CRow>
        </CContainer>
      </div>

      <div
        v-if="viewType == 'Grid View'"
        class="main-card"
        style="padding: 3rem 0 2rem"
      >
        <CDataTable
          class="table-admin"
          responsive
          :items="items"
          :fields="fields"
          column-filter
          hover
          striped
          pagination
          sorter
          style="padding-left: 0; padding-right: 0"
        >
          <template #name="{ item }">
            <td class="align-items-left">
              <div class="course-name" @click="goToCourseDetail(item.no)">
                {{ item.name }}
              </div>
            </td>
          </template>
        </CDataTable>
      </div>
    </CRow>
    <!-- <CustomConfirmModalAlert modalTitle="Add course" modalDetails="The next phase's update plan" /> -->
  </CContainer>
</template>

<script>
import sortingCourse from "../../dropdown/sortingCourse";
import courseCardOverview from "../../card/courseCardOverview";
import CustomConfirmModalAlert from "../../modal/CustomConfirmModalAlert";
import alphabeticalOrder from "../../dropdown/alphabeticalOrder";
import amountOrder from "../../dropdown/amountOrder";
import addANewCourseModal from "../../modal/courseManagement/addANewCourseModal";
const fields = [
  { key: "no", label: "NO." },
  { key: "name", label: "ACRONYM" },
  { key: "fullname", label: "COURSE NAME" },
  { key: "enrolled", label: "ENROLLED" },
  { key: "complete", label: "COMPLETED" },
  { key: "post", label: "POSTED" },
];

export default {
  name: "courseRecordOverview",
  props: {
    instructorCoursesProps: Array,
  },
  components: {
    sortingCourse,
    courseCardOverview,
    CustomConfirmModalAlert,
    alphabeticalOrder,
    amountOrder,
    addANewCourseModal,
  },
  data() {
    return {
      authorNameSearchString: "",
      sortBy: "Sort by Newest",
      search: "",
      viewType: "Table View",
      instructorsCourseData: [],
      fields,
      isAddCourseModalShow: false,
      keyword: {
        name: null,
      },
      items: [],
      searchCourseResult: [],
    };
  },
  computed: {},
  watch: {
    instructorCoursesProps: function () {
      this.instructorsCourseData = this.instructorCoursesProps;
    },
  },
  created() {
    this.$store.commit("language/setChangingSidebar", true);
  },
  mounted() {},
  methods: {
    goToCourseDetail(courseCode) {
     
      let course = this.instructorCoursesProps[courseCode - 1];
      let courseId = course.courseId;
      let body = {
        courseId: courseId,
        courseName: course.name[0].val,
        section: course.section,
        semester: course.semester,
      };
      this.$store.commit("courses/setCourseId", body);
      this.$router.push("/course-management/course-detail");
      
      // alert('We are going to '+courseCode+ ` <== course detail` )
    },
    sumEnrolled(courseProps) {
      let sumHolderOld = 0;
      let sumHolderNew = 0;
      let enrolledSectionCounter = courseProps.section.length;
      for (let i = 0; i < enrolledSectionCounter; i++) {
        sumHolderNew = courseProps.section[i].userEnroll;
        let sumHolder = courseProps.section[i].userEnroll + sumHolderOld;
        sumHolderOld = sumHolder;
      }
      return sumHolderOld;
    },
    sumCompleted(courseProps) {
      let sumHolderOld = 0;
      let sumHolderNew = 0;
      let enrolledSectionCounter = courseProps.section.length;
      for (let i = 0; i < enrolledSectionCounter; i++) {
        sumHolderNew = courseProps.section[i].userComplete;
        let sumHolder = courseProps.section[i].userComplete + sumHolderOld;
        sumHolderOld = sumHolder;
      }
      return sumHolderOld;
    },
    setData() {
      this.items = [];
      if (this.instructorCoursesProps.length > 0) {
        this.instructorCoursesProps.forEach((element, index) => {
          let name = element.title.filter((a) => {
            if (a.key == "en") return a.val;
          });
          let fullname = element.name.filter((a) => {
            if (a.key == "en") return a.val;
          });
          let enroll = this.sumEnrolled(element);
          let complete = this.sumCompleted(element);
          let data = {
            no: index + 1,
            name: name[0].val,
            fullname: fullname[0].val,
            enrolled: enroll,
            complete: complete,
            post: 0,
          };
          this.items.push(data);
        });
      }
    },
    searchFunction(searchText) {
      let searcHolder = this.courses.filter(searchText);
    },
    setViewType(viewType) {
      
      switch (viewType) {
        case "Grid View":
          this.viewType = "Table View";
          break;
        case "Table View":
          this.viewType = "Grid View";
          this.setData();
          break;
      }
    },
    findItem(keyWord) {
      this.items = [];
      for (let i = 0; i <= this.instructorsCourseData.length; i++) {
        let eachItem = this.instructorsCourseData[i];
        if (keyWord.name == eachItem.name[0].val) {
          this.items.push(eachItem);
          // this.setCourse(this.items);
        }
      }

    },
    // setCourse(data) {
    //   this.instructorsCourseData = [];
    //   for (let i = 0; i < data.data.length; i++) {
    //     this.instructorsCourseData.push(data.data[i]);
    //   }
    // },
    setIsAddCourseModalShow() {
      this.isAddCourseModalShow = !this.isAddCourseModalShow;
    },
    checkSortText(sortText) {
      if (sortText == "Sort by Newest") {
        this.sortBy = "Sort by Newest";
        alert(
          "Cant sort by date , api doesn't provide now // Updated 22 June 9:35 AM"
        );
        // this.sortingByDate();
      } else if (sortText == "Sort by Name") {
        this.sortBy = "Sort by Name";
        this.sortingByName();
      } else if (sortText == "Sort by Online User") {
        this.sortBy = "Sort by User";
        alert(
          "Cant sort by Online User , api doesn't provide now // Updated 22 June 9:35 AM"
        );
        // this.sortingByOnlineUser();
      } else if (sortText == "Sort by Enrolled User") {
        this.sortBy = "Sort by Enrolled User";
        alert(
          "Cant sort by Enrolled User , api doesn't provide now // Updated 22 June 9:35 AM"
        );

        // this.sortingByEnrolledUser();
      } else if (sortText == "Sort by Complete") {
        this.sortBy = "Sort by Complete";
        alert(
          "Cant sort by Complete , api doesn't provide now // Updated 22 June 9:35 AM"
        );

        // this.sortingByCompleteNumber();
      } else if (sortText == "Sort by Posted") {
        this.sortBy = "Sort by Posted";
        //this.sortingByPostedNumber();
        alert(
          "Cant sort by Posted , api doesn't provide now // Updated 22 June 9:35 AM"
        );
      } else if (sortText == "Sort by Sharing") {
        this.sortBy = "Sort by Sharing";
        //this.sortingBySharingNumber();
        alert(
          "Cant sort by Sharing , api doesn't provide now // Updated 22 June 9:35 AM"
        );
      } else if (sortText == "Sort by Income") {
        this.sortBy = "Sort by Income";
        //this.sortingByIncomeNumber();
        alert(
          "Cant sort by Income , api doesn't provide now // Updated 22 June 9:35 AM"
        );
      }
    },
    sortingByDate() {
      let courseHolder = this.instructorsCourseData;
      courseHolder.sort(function (a, b) {
        var dateA = new Date(a.date),
          dateB = new Date(b.date);
        return dateA - dateB;
      });
      this.setCourse(courseHolder);
    },
    // sortingByName() {
    //   let courseHolder = this.instructorsCourseData;
    //   courseHolder.sort(function (a, b) {
    //     var titleA = a.name[0].val.toLowerCase(),
    //       titleB = b.name[0].val.toLowerCase();
    //     if (titleA < titleB) return -1;
    //     if (titleA > titleB) return 1;
    //     return 0;
    //   });
    // },
    sortingByOnlineUser() {
      let courseHolder = this.instructorsCourseData;
      courseHolder.sort(function (a, b) {
        return a.online - b.online;
      });
      this.setCourse(courseHolder);
    },
    sortingByEnrolledUser() {
      let courseHolder = this.instructorsCourseData;
      courseHolder.sort(function (a, b) {
        return a.enrolled - b.enrolled;
      });
      this.setCourse(courseHolder);
    },
    sortingByCompleteNumber() {
      let courseHolder = this.instructorsCourseData;
      courseHolder.sort(function (a, b) {
        return a.complete - b.complete;
      });
      this.setCourse(courseHolder);
    },
    sortingByPostedNumber() {
      let courseHolder = this.instructorsCourseData;
      courseHolder.sort(function (a, b) {
        return a.post - b.post;
      });
      this.setCourse(courseHolder);
    },
    sortingBySharingNumber() {
      let courseHolder = this.instructorsCourseData;
      courseHolder.sort(function (a, b) {
        return a.sharing - b.sharing;
      });
      this.setCourse(courseHolder);
    },
    sortingByIncomeNumber() {
      let courseHolder = this.instructorsCourseData;
      courseHolder.sort(function (a, b) {
        return a.income - b.income;
      });
      this.setCourse(courseHolder);
    },
    orderOption(sortBy) {
      if (sortBy === "Sort by Newest") {
        return null;
      } else if (sortBy === "Sort by Name") {
        return "alphabeticalOrder";
      } else {
        return "amountOrder";
      }
    },
  },
};
</script>
<style>
.button-grey:hover {
  box-shadow: 2px 2px 8px grey;
}
.course-name {
  white-space: nowrap;
  width: 145px;
  overflow: hidden;
  text-overflow: ellipsis !important;
  /* border: 1px solid #000000; */
}
.course-name:hover {
  color: #ff693a !important;
  text-decoration: underline !important;
  cursor: pointer;
}
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

table {
  font-size: 16px !important;
}
tr {
  border: none !important;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: white;
}
table tr:nth-child(even) {
  background-color: #fff7f5;
}
</style>